module.exports = __webpack_public_path__ + "static/media/giorgio-armani-acqua-di-gioa-women-big.152cae41.png";